import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "page-max-width q-mx-auto q-pa-sm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Identité et coordonnées", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Dénomination sociale : ESP Kobudo, association loi 1901.", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Siège social : ESP Kobudo chez M. KELLAL Jean-Baptiste - 78610 Le Perray-en-Yvelines ", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Directeur de publication : Jean-Baptiste KELAL", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Développement et intégration", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Réalisation par M. Brice Lallement", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "Hébergement", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Infomaniak Network SA", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Rue Eugène Marziano 25 - 1227 Les Acacias (GE) - Suisse", -1 /* HOISTED */)

import { ref, toRefs, onMounted, onBeforeUnmount } from 'vue';
import { useQuasar } from 'quasar';

// Personal components
import QCustomFab from '@components/QCustomFab.vue';
import QPageTitle from '@components/QPageTitle.vue';

// Personal libs
import { scrollToTop } from '@shared/lib/tools.lib';
import bus from '@shared/lib/eventbus.lib';
import { BusEventEnum } from '@shared/enum/bus/bus-events.enum';
import { $t } from '@i18n/utils';

/**
 * Globals
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'MentionsLegalesPage',
  props: {
  displayTitle: { required: false, type: Boolean, default: true },
},
  setup(__props) {

// Vendor
const $q = useQuasar();

/**
 * Data
 */
const showGoToTopButton = ref<boolean | undefined>(false);

/**
 * Computed properties
 */
const props = __props;
const { displayTitle } = toRefs(props);

/**
 * Methods
 */
function onScroll(position) {
  showGoToTopButton.value = position.position != 0;
}

/**
 * Hooks
 */
onMounted(() => {
  // Events
  bus.on(BusEventEnum.SCROLL_EVENT, (position) => {
    if (displayTitle.value) {
      onScroll(position);
    }
  });
});

onBeforeUnmount(() => {
  showGoToTopButton.value = undefined;

  bus.off(BusEventEnum.SCROLL_EVENT);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`cgu full-width q-mx-auto page-container ${
      _unref($q).dark.isActive ? 'text-white' : 'text-black'
    }`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(displayTitle))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(QPageTitle, { title: "Mentions légales" })
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Editeur "),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("p", null, [
        _createTextVNode(" Contact : "),
        _createElementVNode("a", {
          href: "mailto:espkobudo.78@hotmail.fr",
          target: "_blank",
          class: _normalizeClass(_unref($q).dark.isActive ? 'router-link-white' : 'router-link-black'),
          title: "Envoyer un mail à espkobudo.78@hotmail.fr (nouvelle fenêtre)"
        }, " espkobudo.78@hotmail.fr ", 2 /* CLASS */)
      ]),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _createElementVNode("p", null, [
        _createTextVNode(" Lien : "),
        _createElementVNode("a", {
          href: "https://www.infomaniak.com/fr",
          target: "_blank",
          class: _normalizeClass(_unref($q).dark.isActive ? 'router-link-white' : 'router-link-black'),
          title: "Aller sur le site d'Infomaniak - https://www.infomaniak.com/fr (nouvelle fenêtre)"
        }, " https://www.infomaniak.com/fr ", 2 /* CLASS */)
      ]),
      _createCommentVNode(" Got to top button "),
      _createVNode(QCustomFab, {
        display: _unref(displayTitle) && showGoToTopButton.value === true,
        label: _unref($t)('generic.goToTop.page'),
        alt: _unref($t)('generic.goToTop.page'),
        action: _unref(scrollToTop)
      }, null, 8 /* PROPS */, ["display", "label", "alt", "action"])
    ])
  ], 2 /* CLASS */))
}
}

})